import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, FlexBox, Icon, NavigationButton, Text, } from '@dixa/lib-shared-habla';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './messagingPlatformCard.module.scss';
export const MessagingPlatformCard = (props) => {
    const navigate = useNavigate();
    const renderButton = () => {
        if (props.button)
            return props.button;
        if (props.buttonLink) {
            return (_jsx(NavigationButton, Object.assign({ variant: "primary", navigate: () => navigate({ pathname: props.buttonLink }) }, { children: props.buttonText })));
        }
        return (_jsx(Button, Object.assign({ variant: "primary", className: styles.button, onClick: props.buttonClick }, { children: props.buttonText })));
    };
    return (_jsxs(FlexBox, Object.assign({ flexDirection: "column", alignItems: "flex-start", className: styles.root }, { children: [props.icon && _jsx(Icon, { name: props.icon, size: 24 }), _jsx(Text.Heading, Object.assign({ className: styles.headline }, { children: props.headline })), _jsx(FlexBox, Object.assign({ flexDirection: "column", className: styles.content }, { children: props.children })), renderButton()] })));
};
